export default __webpack_public_path__ + "static/media/clickit.6cc40bbc.svg";